import { render, staticRenderFns } from "./CMSUserManagedHome.vue?vue&type=template&id=c52bfc30&"
import script from "./CMSUserManagedHome.vue?vue&type=script&lang=js&"
export * from "./CMSUserManagedHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports